import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import HttpClient from '../../utils/HttpClient';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import nothoto from "../../Images/nophoto.jpg"

Modal.setAppElement('#root');

const BusinessLIstingModal = ({ isOpen, closeModal, details }) => {
    const [tableData, setTableData] = useState([]);
    const [BcryptPassword, setBcryptPassword] = useState("")
    const navigate = useNavigate()
    const format1 = "DD-MM-YYYY";

    // const handleClickid = (id) => {
    //     navigate('/recently-added-user', { state: id })
    // }

    // fetch Category DAta
    const getCategoryData = async () => {
        const res = await HttpClient.requestData('single-user/' + details, 'GET', {});
        if (res && res?.status) {
            const token = res?.data?.[0]?.token;
            if (token) {
                const decoded = jwtDecode(token);
                setTableData(res?.data);
                setBcryptPassword(decoded?.password)
            }
        }
    }
    // const handleDownload = () => {
    //     const link = document.createElement("a");
    //     link.href = tableData?.[0]?.qrCode;
    //     link.download = tableData?.[0]?.qrCode;
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };
    useEffect(() => {
        getCategoryData();
    }, [details]);
    return (

        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Details Modal"
            className=""
        >
            <a href='#' className='mtclose' onClick={closeModal}><i className="fa-solid fa-xmark"></i></a>


            <>
                <div className=' container'>
                    <div className=' row '>
                        <div className='col-12 d-flex justify-content-center '>
                            <h2 className='  border-bottom border-danger mb-3'>Business Listing Details</h2>

                        </div>
                        <hr />
                        {/* <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Date & Time Created :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{moment(tableData?.[0]?.createdOn).format(format1)}</p>
                        </div> */}
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Customer code:</h4>
                            <p className='mt-1'>{tableData?.[0]?.SLNo || "N/A"}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Created Date:</h4>
                            <p className='mt-1'>{moment(tableData?.[0]?.createdOn).format(format1) || ""}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Email:</h4>
                            <p className='mt-1'>{tableData?.[0]?.emailId || "N/A"}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Password:</h4>
                            <p className='mt-1'>{tableData?.[0]?.passwordView || "********"}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Company name:</h4>
                            <p className='mt-1'>{tableData?.[0]?.companyName || "N/A"}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4 mt-5'>Banner :</h4>
                            <img src={tableData?.[0]?.businesBanner || nothoto} alt="" id='preview'
                                style={{
                                    maxHeight: "128px",
                                }}
                            />

                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4 mt-5'>Logo :</h4>
                            <img src={tableData?.[0]?.businessProfilePic || nothoto} alt="" id='preview'
                                style={{
                                    maxHeight: "128px",
                                }}
                            />

                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>About Us :</h4>
                            <p className='mt-1'>{tableData?.[0]?.aboutBusiness || "N/A"}</p>
                        </div>

                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Services :</h4>
                            <p className='mt-1'>{tableData?.[0]?.businessProductCat?.map((item) => { return `${item}, ` }) || "N/A"}</p>
                        </div>

                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Search Keywords :</h4>
                            <p className='mt-1'>{tableData?.[0]?.businessProductkeywords?.map((item) => { return `${item}, ` }) || "N/A"}</p>
                        </div>
                        {
                            tableData?.[0]?.gallery && (tableData?.[0]?.gallery.length > 0) && (
                                <>
                                    <div className='col-12 d-flex mt-3'>
                                        <h4 className='item-description col-4 mt-5'>Gallery :</h4>
                                        {
                                            tableData?.[0]?.gallery.map((item, key) => {
                                                return <>
                                                    {/* <img src={item.image} alt={item.title} id='preview' height="150px" width="150px" className='mr-2' /><p>{item.title}</p> */}

                                                    <div className="col-md-2">
                                                        <div className="thumbnail">
                                                            <img src={item?.image} alt={item?.title}
                                                                style={{
                                                                    width: "100%",
                                                                }} />
                                                            <div className="caption"
                                                                style={{
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                <p>{item?.title}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            })
                                        }

                                    </div>
                                </>
                            )
                        }
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Phone:</h4>
                            <p className='mt-1'>{tableData?.[0]?.phone_code} - {tableData?.[0]?.telephoneNo || "N/A"}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Mobile:</h4>
                            <p className='mt-1'>{tableData?.[0]?.phone_code} - {tableData?.[0]?.mobileNo || "N/A"}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>WhatsApp:</h4>
                            <p className='mt-1'>{tableData?.[0]?.whats_code} - {tableData?.[0]?.whatsappNo || "N/A"}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Website Link :</h4>
                            <p className='mt-1'>{tableData?.[0]?.businessWebsiteLink || "N/A"}</p>
                        </div>

                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Location Link :</h4>
                            <p className='mt-1'>{tableData?.[0]?.businessLocationLink || "N/A"}</p>
                        </div>

                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Social links :</h4>
                            <p className='mt-1'>
                                <i className="fa fa-2x fa-facebook-f mr-2" style={{ width: "25px" }}></i>{tableData?.[0]?.businessFacebookLink || "N/A"}<br />
                                <i className="fa fa-2x fa-instagram mr-2" style={{ width: "25px" }}></i>{tableData?.[0]?.businessInstaLink || "N/A"}<br />
                                <i className="fa fa-2x fa-linkedin mr-2" style={{ width: "25px" }}></i>{tableData?.[0]?.businessLinkedInLink || "N/A"}
                            </p>
                        </div>
                    </div>
                </div>
            </>
        </Modal >
    );
};

export default BusinessLIstingModal;
